(function(Manogi, $, undefined) {
    
    //Private

    //Public
    

   
    Manogi.validateLogin = function() {
        $.oc.stripeLoadIndicator.show();
        var $form = $('#login-form');
        $form.request('account::onLogin', {
            success: function(response) {
                if(response.success){
                    window.location.reload();
                }
                else{
                    $.oc.stripeLoadIndicator.hide();
                    $('#login-form *[name=email]').addClass('u-error');
                    $('#login-form *[name=password]').addClass('u-error');
                    $('#login-form .js-message').addClass('u-error').text(response.message);
                }
            }
        });
    };

    Manogi.openLoginModal = function(mode) {
        if (typeof(mode) == 'undefined') {
            mode =  'regular';
        }
        
        $.oc.stripeLoadIndicator.show();
        $.ajax({
            url: '/ajax/content/login',
            dataType: 'html',
            success: function(response){
                $.oc.stripeLoadIndicator.hide();
                var message = '';
                if (mode == 'already_registered') {
                    message = 'Mit dieser E-Mail-Adresse ist bereits ein Kundenkonto verknüpft. Bitte loggen Sie sich ein:';
                }

                Manogi.openModal({
                    form : response,
                    message : message,
                    show_confirm : true,
                    show_cancel : true,
                    confirm_text : Manogi.translate('login'),
                    cancel_text : Manogi.translate('cancel'),
                    confirm_action : function() { Manogi.validateLogin(); },
                });

                if (mode == 'already_registered') {
                    var email = $('.form-segment__input[name=email]').val();
                    $('.modal-form__input[name=email]').val(email);
                }
            }
        });
    };

    Manogi.validatePasswordForgotten = function() {
        $.oc.stripeLoadIndicator.show();
        var $form = $('#password-form');
        $form.request('account::onPasswordForgotten', {
            success: function(response) {
                if(response.success){
                    window.location.reload();
                }
                else{
                    $.oc.stripeLoadIndicator.hide();
                    $('#password-form *[name=email]').addClass('u-error');
                    $('#password-form .js-message').addClass('u-error').text(response.message);
                }
            }
        });
    };


    Manogi.openPasswordModal = function() {
        $.oc.stripeLoadIndicator.show();
        $.ajax({
            url: '/ajax/content/forgot_password',
            dataType: 'html',
            success: function(response){
                $.oc.stripeLoadIndicator.hide();

                Manogi.openModal({
                    message : Manogi.translate('temporary_password_explanation'),
                    form : response,
                    show_confirm : true,
                    show_cancel : true,
                    confirm_text : Manogi.translate('send_temporary_password'),
                    cancel_text : Manogi.translate('cancel'),
                    confirm_action : function() { Manogi.validatePasswordForgotten(); },
                });

                var email = $('input[name=email]').val();
                $('.modal-form__input[name=email]').val(email);


            }
        });
    };
    


}( window.Manogi = window.Manogi || {}, jQuery ));